'use client';
import Icon from '@/components/ui/AppIcon';
import SignatureAkif from './SignatureAkif';

export default function FooterSection() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="relative py-10 overflow-hidden"
      style={{ borderTop: '1px solid var(--glass-border)' }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 50% 100% at 50% 100%, rgba(108,99,255,0.06) 0%, transparent 70%)',
        }}
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + Copyright */}
          <div className="flex flex-col md:flex-row items-center md:items-center gap-2 md:gap-4">
            {/* Logo */}
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center font-extrabold text-sm mr-2 mb-6 md:mb-0"
              style={{
                background: 'linear-gradient(135deg, #6C63FF, #00D4FF)',
                color: 'white',
              }}
            >
              <SignatureAkif />
            </div>

            {/* Copyright */}
            <span className="text-sm" style={{ color: 'var(--text-muted)' }}>
              © {year} Akif Khan. Crafted with precision.
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            {['Privacy', 'Terms', 'Sitemap'].map((link) => (
              <a
                key={link}
                href="#"
                className="text-sm transition-colors duration-200"
                style={{ color: 'var(--text-muted)' }}
                onMouseEnter={(e) =>
                  ((e.target as HTMLAnchorElement).style.color = 'var(--text-primary)')
                }
                onMouseLeave={(e) =>
                  ((e.target as HTMLAnchorElement).style.color = 'var(--text-muted)')
                }
              >
                {link}
              </a>
            ))}
          </div>

          {/* Social icons */}
          <div className="flex items-center gap-3">
            {[
              { icon: 'CodeBracketIcon', label: 'GitHub', href: '#' },
              { icon: 'LinkIcon', label: 'LinkedIn', href: '#' },
              { icon: 'ChatBubbleLeftIcon', label: 'Twitter', href: '#' },
              { icon: 'EnvelopeIcon', label: 'Email', href: 'mailto:akif.tm@gmail.com' },
            ].map(({ icon, label, href }) => (
              <a
                key={label}
                href={href}
                title={label}
                className="w-9 h-9 rounded-xl flex items-center justify-center glass-card hover:scale-110 transition-all duration-300"
                style={{ color: 'var(--text-muted)' }}
              >
                <Icon name={icon as 'CodeBracketIcon'} size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
